module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', [(_vm.checked) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.checked) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e161f20e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Checkbox.vue
// module id = 470
// module chunks = 0